(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-premium"]) return;
  try {
    
document.addEventListener('click', function (event) {
  const thumbnail = event.target.closest('[data-gallery-thumb]');
  if (!thumbnail) return;

  const gallery = thumbnail.closest('[data-product-gallery]');
  const mainImage = gallery && gallery.querySelector('[data-gallery-main] img');
  if (!mainImage || thumbnail.getAttribute('aria-pressed') === 'true') return;

  gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (button) {
    const isSelected = button === thumbnail;
    button.classList.toggle('is-active', isSelected);
    button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
  });

  mainImage.classList.add('is-changing');
  mainImage.removeAttribute('srcset');
  mainImage.src = thumbnail.dataset.imageSrc;
  mainImage.alt = thumbnail.dataset.imageAlt || '';
  mainImage.onload = function () {
    mainImage.classList.remove('is-changing');
  };
  window.setTimeout(function () {
    mainImage.classList.remove('is-changing');
  }, 400);
});

  } catch(e) { console.error(e); }
})();
})();
